import React, { FC, ReactNode, useEffect, useState } from 'react';
import { DashboardContext } from './context';
import { CoKitchenType } from 'models/cokitchen.model';
import { STORAGE_KEYS } from 'utils/constants';
import { handleApiError, initKitchenData } from 'utils/functions';
import { apiService } from 'utils/api';
import { ENUM_RIDER_STATUS } from 'utils/enum';
import { LogisticConfigType } from 'models/polygon.model';

const DashboardProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [activeCokitchen, setActiveCokitchen] = useState<CoKitchenType>({} as CoKitchenType);
  const [loading, setLoading] = useState(false);
  const [loadingExternalRiderCount, setLoadingExternalRiderCount] = useState(false);
  const [shouldRefetchBrands, setShouldRefetchBrands] = useState(0);
  const [checkReactivationTime, setCheckReactivationTime] = useState(0);
  const [cokitchenArray, setCokitchenArray] = useState<CoKitchenType[]>([]);
  const [riderCount, setRiderCount] = useState({ count: '0' });
  const [selectedPolygonLogisticsConfig, setSelectedPolygonLogisticsConfig] = useState<{
    polygonId: string;
    logisticsConfig: LogisticConfigType;
    bulkUpdate: boolean;
  }>();

  const handleGetNewExternalRiderCount = async () => {
    setLoadingExternalRiderCount(true);
    try {
      const res = await apiService.get(
        `rider-applications/count?status_filter=${ENUM_RIDER_STATUS.AWAITING_APPROVAL}`,
        {
          baseUrl: process.env.REACT_APP_AUTH_API_URL
        }
      );

      if (res?.data) {
        setRiderCount(res.data);
      }
    } catch {
      handleApiError('An error occurred while fetching new external rider count.');
    } finally {
      setLoadingExternalRiderCount(false);
    }
  };
  useEffect(() => {
    handleGetNewExternalRiderCount();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setCokitchenArray(await initKitchenData());
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (cokitchenArray.length > 0) {
      setDefaultLocation();
    }
  }, [cokitchenArray]);

  const setDefaultLocation = () => {
    const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN) ?? cokitchenArray[0]?.id;
    const defaultCokitchen =
      cokitchenArray.find(({ id }) => id === cokitchenId) ?? cokitchenArray[0];
    setActiveCokitchen(defaultCokitchen);
    localStorage.setItem(STORAGE_KEYS.COKITCHEN, defaultCokitchen?.id);
  };

  return (
    <DashboardContext.Provider
      value={{
        activeCokitchen,
        setActiveCokitchen,
        loading,
        setLoading,
        shouldRefetchBrands,
        setShouldRefetchBrands,
        checkReactivationTime,
        setCheckReactivationTime,
        riderCount,
        loadingExternalRiderCount,
        selectedPolygonLogisticsConfig,
        setSelectedPolygonLogisticsConfig
      }}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
